import React from "react"
import { AlertTriangle } from "lucide-react"
import { Button } from "@/components/ui/button"

interface Props {
  children: React.ReactNode
  fallback?: React.ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[ErrorBoundary]", error, info.componentStack)
  }

  private handleRetry = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback

      return (
        <div role="alert" className="flex flex-col items-center justify-center min-h-[60vh] px-6 py-12 text-center">
          <span className="h-10 w-10 rounded-lg bg-negative-50 dark:bg-negative-950 text-negative-700 dark:text-negative-300 flex items-center justify-center mb-4">
            <AlertTriangle className="h-5 w-5" />
          </span>
          <h2 className="text-[18px] font-semibold tracking-[-0.01em]">Esta tela não carregou</h2>
          <p className="text-[14px] text-muted-foreground mt-1 max-w-sm">
            Algo deu errado do nosso lado. Seus dados estão salvos; tente de novo ou volte ao painel.
          </p>
          <div className="flex gap-2 mt-6">
            <Button onClick={this.handleRetry}>Tentar de novo</Button>
            <Button variant="outline" onClick={() => { window.location.href = "/dashboard" }}>Ir para o painel</Button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
